import { c as _c } from "react/compiler-runtime";
import type { MutableRefObject } from 'react';
import Link from 'next/link';
import type { MinimalWave } from '@/contexts/wave/hooks/useEnhancedWavesList';
import BrainLeftSidebarWaveDropTime from '@/components/brain/left-sidebar/waves/BrainLeftSidebarWaveDropTime';
import BrainLeftSidebarWavePin from '@/components/brain/left-sidebar/waves/BrainLeftSidebarWavePin';
import { WaveAvatar } from './WaveAvatar';
import { WaveTooltip, WaveTooltipPlacement } from './WaveTooltip';
interface ExpandedWaveProps {
  readonly formattedWaveName: string;
  readonly haveNewDrops: boolean;
  readonly href: string;
  readonly isActive: boolean;
  readonly isDropWave: boolean;
  readonly isPinned: boolean;
  readonly latestDropTimestamp?: number | null;
  readonly nameRef: MutableRefObject<HTMLDivElement | null>;
  readonly onMouseEnter?: () => void;
  readonly onClick: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  readonly showExpandedTooltip: boolean;
  readonly showPin: boolean;
  readonly tooltipContent: string;
  readonly tooltipId: string;
  readonly tooltipPlacement: WaveTooltipPlacement;
  readonly wave: MinimalWave;
  readonly waveId: string;
}
export const ExpandedWave = t0 => {
  const $ = _c(39);
  const {
    formattedWaveName,
    haveNewDrops,
    href,
    isActive,
    isDropWave,
    isPinned,
    latestDropTimestamp,
    nameRef,
    onMouseEnter,
    onClick,
    showExpandedTooltip,
    showPin,
    tooltipContent,
    tooltipId,
    tooltipPlacement,
    wave,
    waveId
  } = t0;
  let t1;
  if ($[0] !== showExpandedTooltip || $[1] !== tooltipContent || $[2] !== tooltipId) {
    t1 = showExpandedTooltip ? {
      "data-tooltip-id": tooltipId,
      "data-tooltip-content": tooltipContent
    } : {};
    $[0] = showExpandedTooltip;
    $[1] = tooltipContent;
    $[2] = tooltipId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const tooltipAttributes = t1;
  const t2 = `tw-group tw-flex tw-items-start tw-gap-x-4 tw-px-5 tw-py-2 tw-transition-all tw-duration-200 tw-ease-out ${isActive ? "tw-bg-iron-700/60 desktop-hover:hover:tw-bg-iron-700/70" : "desktop-hover:hover:tw-bg-iron-800/80"}`;
  const t3 = `tw-flex tw-flex-1 tw-min-w-0 tw-space-x-3 tw-no-underline tw-py-1 tw-transition-all tw-duration-200 tw-ease-out ${isActive ? "tw-text-white desktop-hover:group-hover:tw-text-white tw-font-medium" : "tw-text-iron-400 desktop-hover:group-hover:tw-text-iron-300 tw-font-normal"}`;
  const t4 = !isActive && haveNewDrops;
  let t5;
  if ($[4] !== isActive || $[5] !== isDropWave || $[6] !== t4 || $[7] !== wave) {
    t5 = <div className="tw-relative"><WaveAvatar isActive={isActive} isDropWave={isDropWave} showNewDropsBadge={t4} wave={wave} /></div>;
    $[4] = isActive;
    $[5] = isDropWave;
    $[6] = t4;
    $[7] = wave;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== formattedWaveName || $[10] !== nameRef || $[11] !== tooltipAttributes) {
    t6 = <div ref={nameRef} className="tw-text-sm -tw-mt-0.5 tw-mb-0.5 tw-truncate" {...tooltipAttributes}>{formattedWaveName}</div>;
    $[9] = formattedWaveName;
    $[10] = nameRef;
    $[11] = tooltipAttributes;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== latestDropTimestamp) {
    t7 = !!latestDropTimestamp && <div className="tw-text-xs tw-text-iron-500"><span className="tw-pr-1">Last drop:</span><BrainLeftSidebarWaveDropTime time={latestDropTimestamp} /></div>;
    $[13] = latestDropTimestamp;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6 || $[16] !== t7) {
    t8 = <div className="tw-flex-1 tw-min-w-0">{t6}{t7}</div>;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== href || $[19] !== onClick || $[20] !== onMouseEnter || $[21] !== t3 || $[22] !== t5 || $[23] !== t8) {
    t9 = <Link href={href} onMouseEnter={onMouseEnter} onClick={onClick} className={t3}>{t5}{t8}</Link>;
    $[18] = href;
    $[19] = onClick;
    $[20] = onMouseEnter;
    $[21] = t3;
    $[22] = t5;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== isPinned || $[26] !== showPin || $[27] !== waveId) {
    t10 = showPin && <BrainLeftSidebarWavePin waveId={waveId} isPinned={isPinned} />;
    $[25] = isPinned;
    $[26] = showPin;
    $[27] = waveId;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== showExpandedTooltip || $[30] !== tooltipContent || $[31] !== tooltipId || $[32] !== tooltipPlacement) {
    t11 = showExpandedTooltip && <WaveTooltip id={tooltipId} place={tooltipPlacement}>{tooltipContent}</WaveTooltip>;
    $[29] = showExpandedTooltip;
    $[30] = tooltipContent;
    $[31] = tooltipId;
    $[32] = tooltipPlacement;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  let t12;
  if ($[34] !== t10 || $[35] !== t11 || $[36] !== t2 || $[37] !== t9) {
    t12 = <div className={t2}>{t9}{t10}{t11}</div>;
    $[34] = t10;
    $[35] = t11;
    $[36] = t2;
    $[37] = t9;
    $[38] = t12;
  } else {
    t12 = $[38];
  }
  return t12;
};